import React from "react";
import { useTranslation } from "react-i18next";

function ImportantText() {
  const { t } = useTranslation();

  return (
    <div className="important-text">
      <p className="important-text__heading">Important</p>
      <p>
      {`${t('status-page.notesBodyLine1')}`}
        <br />
        {`${t('status-page.notesBodyLine2')}`}
      </p>
    </div>
  );
}

export default ImportantText;
